import {Component, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate} from '@angular/router';
import {UnsavedStateService} from '../../../services/unsaved-state.service';

@Injectable()
export class UnsavedGuard implements CanDeactivate<Component> {

    constructor (
        private unsavedStateService: UnsavedStateService
    ) { }

    canDeactivate(component: Component, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): boolean {

        if (this.unsavedStateService.isUnsaved()) {

            if (confirm('There are unsaved changes on the current page. Are you sure you want to leave and lose any unsaved changes?')) {
                this.unsavedStateService.reset();
                return true;
            }

        } else {
            return true;
        }
    }
}
